
'use strict';

var React = require('react');
var PropTypes = require('prop-types');

module.exports = function render(props) {
    var innerHtml = '<g fill="none" fill-rule="evenodd" stroke="#F05323"><path d="M9.414.5a.5.5 0 0 0-.353.146l-8 8a.5.5 0 0 0 0 .708l5.585 5.585a.5.5 0 0 0 .708 0l8-8a.5.5 0 0 0 .146-.353V1a.5.5 0 0 0-.5-.5H9.414z"/><circle cx="12" cy="4" r="1.5"/></g><!-- Filename: sourceSvg/store/offer-icon.svg -->';
    var svgProps = {
        className: props.className ? (props.className + ' uig-svg-icon') : 'uig-svg-icon',
        dangerouslySetInnerHTML: {__html: innerHtml },
        viewBox: '0 0 16 16'
    }
    return React.createElement('svg', Object.assign({}, props, svgProps));
}
    